import { Tag } from "components/DesignSystem/Tag/Tag";
import { ComponentProps } from "react";

export const CREDIT_NOTE_STATUS = {
  AVAILABLE: "AVAILABLE",
  PARTIALLY_APPLIED: "PARTIALLY_APPLIED",
  FULLY_APPLIED: "FULLY_APPLIED",
} as const;

export type CreditNoteStatusType =
  (typeof CREDIT_NOTE_STATUS)[keyof typeof CREDIT_NOTE_STATUS];

export const CREDIT_NOTE_STATUS_TAG_TYPE: Record<
  CreditNoteStatusType,
  ComponentProps<typeof Tag>["tagType"]
> = {
  [CREDIT_NOTE_STATUS.AVAILABLE]: "green",
  [CREDIT_NOTE_STATUS.PARTIALLY_APPLIED]: "orange",
  [CREDIT_NOTE_STATUS.FULLY_APPLIED]: "gray",
};

export const CREDIT_NOTE_STATUS_LABEL: Record<CreditNoteStatusType, string> = {
  [CREDIT_NOTE_STATUS.AVAILABLE]: "Available",
  [CREDIT_NOTE_STATUS.PARTIALLY_APPLIED]: "Partially Applied",
  [CREDIT_NOTE_STATUS.FULLY_APPLIED]: "Fully Applied",
};
